import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { CartoAdm } from 'src/app/models/SiicartAdm/CartoAdm.model';
import { ObjDel } from 'src/app/models/SiicartAdm/ObjDel.model';
import { GroupCartoAdm } from '../../models/SiicartAdm/GroupCartoAdm';


@Injectable({
  providedIn: 'root'
})
export class CartografiaService {
  IdUsuario: number;
  Usuario: any;

  constructor(private http: HttpClientService) { }

  ObtenerCarto() {
    return this.http.get(`${environment.apiScar}Cartografia/ObtenerCartografia`)
      .pipe(map(response => response));
  }
  AgrModfCarto(carto: CartoAdm) {
    return this.http.post(`${environment.apiScar}Cartografia/AgregarModificarCartografia`, carto)
      .pipe(map(response => response));
  }

  EliminarCarto(ids: ObjDel) {
    return this.http.post(`${environment.apiScar}Cartografia/EliminarCartografia`, ids)
      .pipe(map(response => response));
  }

  ObtenerGrpCarto() {
    return this.http.get(`${environment.apiScar}GrupoCartografia/ObtenerGrpCartografia`)
      .pipe(map(response => response));
  }

  AgrModfGrpCarto(carto: GroupCartoAdm) {
    return this.http.post(`${environment.apiScar}GrupoCartografia/AgregarModificarGrpCartografia`, carto)
      .pipe(map(response => response));
  }

  EliminarGrpCarto(ids: ObjDel) {
    return this.http.post(`${environment.apiScar}GrupoCartografia/EliminarGrpCartografia`, ids)
      .pipe(map(response => response));
  }

}
